import type { BrandDomain } from "@appcaire/brand";

export type Domain = BrandDomain;

/**
 * The only place a domain becomes Tailwind classes. Literal strings so the
 * JIT sees them; values resolve through the generated --cb-domain-* tokens.
 * `ai` has no flat solid: its tile is the aurora gradient.
 */
export const domainClasses: Record<
  Domain,
  {
    tint: string;
    solid: string;
    ink: string;
    border: string;
    tileShadow: string;
    /** Form labels inside a domain panel take the domain ink. */
    labelInk: string;
  }
> = {
  planning: {
    tint: "bg-domain-planning-tint",
    solid: "bg-domain-planning-solid",
    ink: "text-domain-planning-ink",
    border: "border-domain-planning-solid/25",
    tileShadow: "shadow-domain-planning-solid/40",
    labelInk: "[&_label]:text-domain-planning-ink",
  },
  care: {
    tint: "bg-domain-care-tint",
    solid: "bg-domain-care-solid",
    ink: "text-domain-care-ink",
    border: "border-domain-care-solid/25",
    tileShadow: "shadow-domain-care-solid/40",
    labelInk: "[&_label]:text-domain-care-ink",
  },
  continuity: {
    tint: "bg-domain-continuity-tint",
    solid: "bg-domain-continuity-solid",
    ink: "text-domain-continuity-ink",
    border: "border-domain-continuity-solid/25",
    tileShadow: "shadow-domain-continuity-solid/40",
    labelInk: "[&_label]:text-domain-continuity-ink",
  },
  attention: {
    tint: "bg-domain-attention-tint",
    solid: "bg-domain-attention-solid",
    ink: "text-domain-attention-ink",
    border: "border-domain-attention-solid/25",
    tileShadow: "shadow-domain-attention-solid/40",
    labelInk: "[&_label]:text-domain-attention-ink",
  },
  human: {
    tint: "bg-domain-human-tint",
    solid: "bg-domain-human-solid",
    ink: "text-domain-human-ink",
    border: "border-domain-human-solid/25",
    tileShadow: "shadow-domain-human-solid/40",
    labelInk: "[&_label]:text-domain-human-ink",
  },
  society: {
    tint: "bg-domain-society-tint",
    solid: "bg-domain-society-solid",
    ink: "text-domain-society-ink",
    border: "border-domain-society-solid/25",
    tileShadow: "shadow-domain-society-solid/40",
    labelInk: "[&_label]:text-domain-society-ink",
  },
  ai: {
    tint: "bg-domain-ai-tint",
    solid:
      "bg-[image:linear-gradient(135deg,hsl(var(--cb-ai-cyan-hsl)),hsl(var(--cb-ai-blue-hsl)),hsl(var(--cb-ai-magenta-hsl)))]",
    ink: "text-domain-ai-ink",
    border: "border-domain-ai-solid/25",
    tileShadow: "shadow-domain-ai-solid/40",
    labelInk: "[&_label]:text-domain-ai-ink",
  },
};
